module.exports = __webpack_public_path__ + "static/img/iswechat-bottom.bf3d0ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/public-modules/img/iswechat-bottom.png
// module id = h6I3
// module chunks = 0